import React, { Component } from 'react';

import Site, {SiteModifier_} from '../utils/Site'
import Each from '../utils/Each'

import Base from '../components/BaseComponent'
import Intro from '../components/Intro'
import Item from '../components/Item'
import Content from '../components/Content'
import Grid from '../components/Grid'
import Media from '../components/Media'
import Newsletter from '../components/Newsletter'
import Button from '../components/Button'
import Image from '../components/Image'
import Filters from '../components/Filters'
import EventsList from '../components/EventsList'
import FadeIn from '../components/FadeIn'
import OpeningTimes from '../components/OpeningTimes'
import CallToAction from '../components/CallToAction'
import Happenings from '../components/Happenings'
import Rates from '../components/Rates'
import LotInfo from '../components/LotInfo'
import LiveGallery from '../components/LiveGallery'
import Amenities from '../components/Amenities'
import ContentBlocks from '../components/ContentBlocks'
import MiniMap from '../components/MiniMap'
import Window from '../components/Window'
import ScrollTo from '../components/ScrollTo'
import Related from '../components/Related';
import ActionLogger from '../components/ActionLogger';
import Tidy from '../components/Tidy';

import Asset from '../models/Asset'
import Entry from '../models/Entry'



class Location extends Component {

	constructor(props) {
		super(props);
	}

	componentDidMount() {

	}

	componentWillUnmount() {

	}

	nl2br = (str) => {
    	let breakTag = '<br />';
    	return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	}

	entryType = (entry) => {
		let type = entry.locationCategory;

		return ( type );

	}

	getAboutTitle = () => {
		switch(this.props.locationCategory) {
			case 'live':
				return 'Get to know';
				break;
			default:
				return 'About'
				break
		}
	}

	getFeature = () => {
		if(this.props.entry.featureImage && this.props.entry.featureImage.length)
		{
			return (
			<Item modifiers={['grid']}>
									<Media id={this.props.entry.featureImage[0]} fluid={false}/>
									</Item>
			)
		} else {
			return null;
		}
	}

	/*

		RENDER

	*/

	render() {

		const {entry} = this.props;



		let intro;
		if(entry.image){

			intro = (
				<div className="Template-intro Template-intro--short">
				<Item modifiers={['intro']}>

					<div className="Item-head">
						<div className="Item-title">
							<Content modifier={'yellow'}>
								<Tidy html={'<h1>'+entry.title+'<h1>'}/>
							</Content>
						</div>
						<div className="Item-subTitle">
							<Content>
								<h4>{entry.locationType}</h4>
							</Content>
						</div>
					</div>
					<div className="Item-media">
						<Media id={entry.image[0]} />
					</div>


				</Item>
				</div>
			)


		}else{

			intro = null;

		}

		return (
			<FadeIn>
			<ScrollTo pos={0}/>
			<div className={"Template  Template--default  Template--location  Template--" + this.entryType(entry) + ""}>

					{/* Template-head */}
					<div className="Template-head">
						{intro}
					</div>
					{/* / Template-head */}
					{/* Template-button */}
					<div className="Template-button">
						<ActionLogger category={entry.locationCategory} action="Call to action click" label={entry.title + ': '+entry.callToActionTitle}>
							<CallToAction location={entry} />
						</ActionLogger>
					</div>
					{/* / Template-button */}
					{/* Template-utils */}
					<div className="Template-utils">

						<OpeningTimes location={entry} />

					</div>
					{/* / Template-utils */}

					{/* Template-body */}
					<div className="Template-body">

						{/*<ContentBlocks blocks={entry.contentBlocks} />*/}

						<div className="Template-sections">

							<div className="Template-section Template-section--narrow">
								<div className="Template-heading">
								<Content modifier={'alt'}>
									<h1>{this.getAboutTitle()}</h1>
								</Content>
								</div>
								<div className="Template-content">
									{this.getFeature()}
									
									<Content html={entry.about}/>
								</div>
							</div>

							{/*<Happenings entry={entry} />*/}

							<Rates entry={entry} />

							<LotInfo entry={entry} />

							<LiveGallery entry={entry} />

							<Amenities entry={entry} />

							<div className="Template-section Template-section--narrow">
								<div className="Template-heading">
								<Content modifier={'alt'}>
									<h1>Where</h1>
								</Content>
								</div>
								<div className="Template-content">
									<Content html={"<p>"+this.nl2br(entry.address)+"</p>"}>
									</Content>
									<MiniMap lat={entry.latitude} lng={entry.longitude}/>
								</div>
							</div>

							<Related to={entry} />
						</div>

					</div>
					{/* / Template-body */}


			</div>
			</FadeIn>
		);

	}
}

export default Location;



// WEBPACK FOOTER //
// ./src/js/templates/Location.js